import { useKitWorkspace } from 'containers/KitWorkspaceStorage/context';
import { readBool } from 'utils/readBool';

/**
 * Whether the kit flow is finished (whole-workspace PDF generated) and the
 * wizard chrome should be locked. Gated by the showManageKits toggle so the
 * legacy flow is never affected. Safe to call anywhere — the KitWorkspaceStorage
 * provider wraps the whole app.
 */
export const useKitLocked = (): boolean => {
  const { workspace } = useKitWorkspace();
  return readBool('variables.showManageKits') && workspace?.status === 'completed';
};

export default useKitLocked;
